import React from 'react';

const Dimmed = ({ classes, children }) => (
  <div className={classes.wrapper}>{children}</div>
);

export default Dimmed;
